import { Grid, useEventCallback } from '@mui/material';
import { ForeignForm } from 'shell/view-models/foreign-form';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { FormikErrors, FormikTouched } from 'formik';
import InputKeyboard from 'shell/components/shared/input-keyboard';

interface ForeignComponentProps {
  disabled?: boolean;
  isEditMode?: boolean;
  values?: ForeignForm;
  errors?: FormikErrors<ForeignForm>;
  touched?: FormikTouched<ForeignForm>;
  onChange: (key: keyof ForeignForm, value: ForeignForm[keyof ForeignForm]) => void;
}

const ForeignComponent = ({
  disabled,
  isEditMode,
  values,
  errors,
  touched,
  onChange,
}: ForeignComponentProps): React.ReactElement => {
  const handleForeignStateListChange = useEventCallback(
    (state: ForeignStateVM | null | undefined) => {
      onChange('state', state);
    }
  );

  const handleInputKeyboardChange = useEventCallback((municipality: string) => {
    onChange('municipality', { description: municipality, province: '', provinceCode: '' });
  });

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} md={6}>
        <ForeignStateList
          value={values?.state || null}
          onChange={handleForeignStateListChange}
          disabled={isEditMode ? false : disabled}
          label="Stato estero di nascita"
          id="foreignStateBirth"
          error={Boolean(errors?.state)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <InputKeyboard
          value={values?.municipality?.description || ''}
          onChange={handleInputKeyboardChange}
          label="Comune estero di nascita"
          id="foreignMunicipality"
          disabled={isEditMode ? false : disabled}
          touched={touched?.municipality && Boolean(errors?.municipality)}
          error={errors?.municipality}
          defaultUppercase
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="county"
          name="county"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.province || values?.municipality?.province || ''}
          onChange={(event) => {
            onChange('province', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

ForeignComponent.displayName = 'Foreign generality component';

const Foreign = memo(ForeignComponent);

export default Foreign;
